import { requireCompletedProfile } from "@hisani/auth";
import { createFarrierRecordSchema, createVetRecordSchema, listHorseFarrierRecordsSchema, listHorseVetRecordsSchema, logFarrierRecordOutcomeSchema, logVetRecordOutcomeSchema, stableConflict, } from "../validation.js";
import { beginSealedRecordDocumentUpload, getSealedRecordDocumentUrl, requireFeatureMembership, requireHorseAcceptingSealedRecords, verifyAndClaimSealedRecordDocuments, } from "./sealed-record-support.js";
// --- Vet Records ---
export function beginVetRecordDocumentUpload(principal, input, dependencies) {
    return beginSealedRecordDocumentUpload(principal, input, "vet-records", "VET_RECORDS", dependencies);
}
export async function createVetRecord(principal, input, dependencies) {
    const actor = requireCompletedProfile(principal);
    const parsed = createVetRecordSchema.parse(input);
    await requireFeatureMembership(dependencies, parsed.stableId, actor.account.id, "VET_RECORDS", "USE");
    await requireHorseAcceptingSealedRecords(dependencies, parsed.stableId, parsed.horseId);
    await verifyAndClaimSealedRecordDocuments(parsed.stableId, "vet-records", parsed.documents, dependencies);
    const now = dependencies.clock.now();
    return dependencies.repository.createVetRecord({
        id: dependencies.newId(),
        stableId: parsed.stableId,
        horseId: parsed.horseId,
        dueDate: parsed.dueDate,
        scheduledNotes: parsed.scheduledNotes,
        outcomeNotes: parsed.outcomeNotes,
        documents: parsed.documents,
        actorId: actor.account.id,
        now,
    });
}
export async function logVetRecordOutcome(principal, input, dependencies) {
    const actor = requireCompletedProfile(principal);
    const parsed = logVetRecordOutcomeSchema.parse(input);
    await requireFeatureMembership(dependencies, parsed.stableId, actor.account.id, "VET_RECORDS", "USE");
    await verifyAndClaimSealedRecordDocuments(parsed.stableId, "vet-records", parsed.documents, dependencies);
    const now = dependencies.clock.now();
    const record = await dependencies.repository.logVetRecordOutcome({
        stableId: parsed.stableId,
        recordId: parsed.recordId,
        expectedVersion: parsed.expectedVersion,
        actorId: actor.account.id,
        outcomeNotes: parsed.outcomeNotes,
        documents: parsed.documents,
        now,
    });
    if (record === null)
        throw stableConflict();
    return record;
}
export async function listHorseVetRecords(principal, input, dependencies) {
    const actor = requireCompletedProfile(principal);
    const parsed = listHorseVetRecordsSchema.parse(input);
    await requireFeatureMembership(dependencies, parsed.stableId, actor.account.id, "VET_RECORDS", "VIEW");
    return dependencies.repository.listHorseVetRecords(parsed);
}
export function getVetRecordDocumentUrl(principal, input, dependencies) {
    return getSealedRecordDocumentUrl(principal, input, "VET_RECORDS", (stableId, documentId) => dependencies.repository.getVetRecordDocument(stableId, documentId), dependencies);
}
// --- Farrier Records ---
export function beginFarrierRecordDocumentUpload(principal, input, dependencies) {
    return beginSealedRecordDocumentUpload(principal, input, "farrier-records", "FARRIER_RECORDS", dependencies);
}
export async function createFarrierRecord(principal, input, dependencies) {
    const actor = requireCompletedProfile(principal);
    const parsed = createFarrierRecordSchema.parse(input);
    await requireFeatureMembership(dependencies, parsed.stableId, actor.account.id, "FARRIER_RECORDS", "USE");
    await requireHorseAcceptingSealedRecords(dependencies, parsed.stableId, parsed.horseId);
    await verifyAndClaimSealedRecordDocuments(parsed.stableId, "farrier-records", parsed.documents, dependencies);
    const now = dependencies.clock.now();
    return dependencies.repository.createFarrierRecord({
        id: dependencies.newId(),
        stableId: parsed.stableId,
        horseId: parsed.horseId,
        dueDate: parsed.dueDate,
        scheduledNotes: parsed.scheduledNotes,
        outcomeNotes: parsed.outcomeNotes,
        documents: parsed.documents,
        actorId: actor.account.id,
        now,
    });
}
export async function logFarrierRecordOutcome(principal, input, dependencies) {
    const actor = requireCompletedProfile(principal);
    const parsed = logFarrierRecordOutcomeSchema.parse(input);
    await requireFeatureMembership(dependencies, parsed.stableId, actor.account.id, "FARRIER_RECORDS", "USE");
    await verifyAndClaimSealedRecordDocuments(parsed.stableId, "farrier-records", parsed.documents, dependencies);
    const now = dependencies.clock.now();
    const record = await dependencies.repository.logFarrierRecordOutcome({
        stableId: parsed.stableId,
        recordId: parsed.recordId,
        expectedVersion: parsed.expectedVersion,
        actorId: actor.account.id,
        outcomeNotes: parsed.outcomeNotes,
        documents: parsed.documents,
        now,
    });
    if (record === null)
        throw stableConflict();
    return record;
}
export async function listHorseFarrierRecords(principal, input, dependencies) {
    const actor = requireCompletedProfile(principal);
    const parsed = listHorseFarrierRecordsSchema.parse(input);
    await requireFeatureMembership(dependencies, parsed.stableId, actor.account.id, "FARRIER_RECORDS", "VIEW");
    return dependencies.repository.listHorseFarrierRecords(parsed);
}
export function getFarrierRecordDocumentUrl(principal, input, dependencies) {
    return getSealedRecordDocumentUrl(principal, input, "FARRIER_RECORDS", (stableId, documentId) => dependencies.repository.getFarrierRecordDocument(stableId, documentId), dependencies);
}
